import { ApiConnector } from 'Connectors/ApiConnector';
import ConfigProxy      from '../../../tools/ConfigProxy';
import AbstractApiModel from './AbstractApiModel';

export const rhConnector = new ApiConnector({
	baseURL: ConfigProxy.getServiceConfig('rh', 'api_endpoint'),
});

export default class RhApiModel extends AbstractApiModel {
	public static get connector() {
		return rhConnector;
	}

	public static serviceName: ServiceName = 'rh';
}
